import React from 'react';
import resolveWithRetry from './resolveWithRetry';

export default function loadLazyComponent(lazyComponent, attempts) {
    return React.lazy(() => resolveWithRetry(lazyComponent, attempts));
}
